import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/app';
import reportWebVitals from './reportWebVitals';
import initIconLibrary from './icon-config';
import history from './common/history';
import { Auth0Provider } from '@cmr/react-auth0';
import { registerServiceWorker } from '@cmr/react-ui-common';
import { ApiProvider } from '@cmr/react-api-hook';

initIconLibrary();

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      client_id='0Y240zyLCrrHX2NSCaiWalD50kq2t2wU'
      autoLoginRedirect
      history={history}
    >
      <ApiProvider>
        <App />
      </ApiProvider>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

registerServiceWorker();

reportWebVitals();
